import { BRAND_TEAM_ROLES } from '@eva/schemas';
import type { SessionContext, BrandDetection } from '@eva/domain';
import { APP_ROUTE_SEGMENTS } from '@shared/config/reserved-slugs';

/** Só o painel administrativo segue a troca explícita. Portas de login e páginas públicas mantêm sua marca. */
export function marcaAdministrativaDaSessao(pathname: string, context: SessionContext | null): BrandDetection | null {
  const segment = pathname.split('/').filter(Boolean)[0] ?? '';
  const adminPage = ['', 'marca', 'contextos', ...APP_ROUTE_SEGMENTS].includes(segment);
  if (!adminPage || !context?.brandId || !BRAND_TEAM_ROLES.includes(context.role)) return null;
  return { identifier: context.brandId, kind: 'id', source: 'session' };
}
